import { Injectable } from '@angular/core';
import { getCssVariable } from './css-variables.lib';

@Injectable()
export class CssVariablesService {
  getCssVariable(name: string, elementName: string = ':root', searchEverywhere = false): Promise<string | undefined> {
    return getCssVariable(name, elementName, searchEverywhere);
  }
}
